var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Network") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/MapFill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#6C7DBC",
    strokeWidth: 2,
    strokeLinejoin: "round",
    points: "19.5523315 4.20709365 14.5174438 6.21126573 9.48255617 4.44905504 4.4476685 6.15916622 4.4476685 19.8424624 9.48255617 17.7915074 14.5174438 19.553718 19.5523315 17.8676943"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.42582703,
    y1: 4.59829521,
    x2: 9.42582703,
    y2: 18.3693771,
    id: "Path-9",
    stroke: "#6C7DBC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.683136,
    y1: 5.7508831,
    x2: 14.683136,
    y2: 19.521965,
    id: "Path-9-Copy",
    stroke: "#6C7DBC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    fill: "#6C7DBC",
    points: "4.4476685 6.15916622 9.42582703 4.59829521 9.24113083 17.6587429 4.4476685 19.2151241"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10-Copy",
    fill: "#6C7DBC",
    points: "14.683136 6.46600712 19.6612945 4.90513611 19.4765983 17.9655838 14.683136 19.521965"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapFill);
export default __webpack_public_path__ + "static/media/MapFill.3334c772f25a6d95df0202cc79328aa6.svg";
export { ForwardRef as ReactComponent };